<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<ng-template *ngTemplateOutlet="treeBranchTpl; context: { $implicit: tree() }"></ng-template>
<ng-template #treeBranchTpl let-folders>
    <ul (dragover)="projectDragAndDropService.drugOver($event); dragOver()" class="tree-list__branch">
        @for (folder of folders; track folder.id) {
            <li class="tree-list__item" (dragover)="projectDragAndDropService.drugOver($event); dragOver()">
                <span
                        class="tree-list__item-name"
                        [ngClass]="{ 'tree-list__item-name--active': folder.isSelected() }"
                        (dragover)="projectDragAndDropService.drugOver($event); dragOver(folder)"
                        (drop)="projectDragAndDropService.drop(folder); dragOver()"
                >
                    @if (folder.hasChildren()) {
                        <button (click)="toggleOpen(folder)" class="tree-list__toggle-folder" windeActionIcon>
                            <sui-svg-icon [icon]="folder.isOpened() ? 'caret-down' : 'caret-right'" windeGrey/>
                        </button>
                    }
                    <span class="d-block"
                          (click)="selectFolder(folder)"
                          (keydown)="selectFolder(folder)"
                          (dblclick)="toggleOpen(folder); selectFolder(folder)">
                        <button windeActionIcon>
                            <sui-svg-icon [icon]="folder.isOpened() ? 'folder-open' : 'folder'" windeGrey/>
                        </button>
                        {{ folder.name }}
                    </span>
                </span>
                @if (folder.hasChildren() && folder.isOpened()) {
                    <ng-template *ngTemplateOutlet="treeBranchTpl; context: { $implicit: folder.children }"></ng-template>
                }
            </li>
        }
    </ul>
</ng-template>
